
import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { Network } from '@capacitor/network';
import { Preferences } from '@capacitor/preferences';
import { useToast } from '@/hooks/use-toast';

export function useNetworkSync() {
  const [isAppOnline, setIsAppOnline] = useState(true);
  const { toast } = useToast();

  const syncOfflineChanges = async () => {
    if (!Capacitor.isNativePlatform()) return;

    try {
      const { value: offlineChanges } = await Preferences.get({ key: 'offlineChanges' });
      if (offlineChanges) {
        const changes = JSON.parse(offlineChanges);
        // Process offline changes here
        // This will be implemented in the notes components
        await Preferences.remove({ key: 'offlineChanges' });
      }
    } catch (error) {
      console.error('Error syncing offline changes:', error);
    }
  };

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      // Set up network status listener
      Network.addListener('networkStatusChange', status => {
        console.log('Network status changed:', status.connected);
        setIsAppOnline(status.connected);
        
        if (status.connected) {
          toast({
            title: "Back Online",
            description: "Your changes will now be synchronized",
          });
          // Trigger sync when coming back online
          syncOfflineChanges();
        } else {
          toast({
            title: "Offline Mode",
            description: "You can continue working. Changes will sync when you're back online",
          });
        }
      });

      // Check initial network status
      Network.getStatus().then(status => {
        setIsAppOnline(status.connected);
      });
    }

    return () => {
      if (Capacitor.isNativePlatform()) {
        Network.removeAllListeners();
      }
    };
  }, []);

  return { isAppOnline, syncOfflineChanges };
}
